/**
 * @module:  运行池模块
 * @author: Liang Huang
 * @date: 2019-09-23 15:13:15
 */
export default function runtimeMixin(hybrid) {
  var hybridJs = hybrid;
  var innerUtil = hybridJs.innerUtil;
  hybridJs.extendModule('runtime', [{
    // 打开第三方APP
    namespace: 'launchApp',
    os: ['ywk'],
    params: {
      // android应用的包名
      packageName: '',
      // android应用页面类名
      className: '',
      // android应用页面配置的ActionName
      actionName: '',
      // 页面配置的Scheme名字，适用于Android与iOS
      scheme: '',
      // 传递的参数。需要目标应用解析获取参数。字符串形式
      data: ''
    }
  }, {
    // 获取容器版本号
    namespace: 'getAppVersion',
    os: ['ywk']
  }, {
    // 清除容器缓存
    namespace: 'clearCache',
    os: ['ywk']
  }, {
    // 获取地理位置
    namespace: 'getGeolocation',
    os: ['ywk'],
    params: {
      isShowDetail: 0,
      // 1采用的火星坐标系，0采用地球坐标系
      coordinate: 1
    }
  }, {
    // 复制文本信息到剪切板
    namespace: 'clipboard',
    os: ['ywk'],
    params: {
      text: ''
    },
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      } // 兼容字符串形式


      var args = innerUtil.compatibleStringParamsToObject.call(this, rest, 'text');
      hybridJs.callInner.apply(this, args);
    }
  }, {
    // 外部浏览器打开url
    namespace: 'openUrl',
    os: ['ywk'],
    params: {
      url: ''
    },
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      } // 兼容字符串形式


      var args = innerUtil.compatibleStringParamsToObject(rest, 'url');
      hybridJs.callInner.apply(this, args);
    }
  }, {
    // 显示客户端登录页面
    namespace: 'showLoginDialog',
    os: ['ywk'],
    params: {}
  }, {
    // 分享
    namespace: 'showShareDialog',
    os: ['ywk'],
    params: {
      detail: '',
      link: '',
      pic: '',
      title: '',
      type: 0 // 0 全渠道； 1 qq、微信、copy

    }
  }, {
    namespace: 'pay',
    os: ['ywk'],
    params: {
      data: {
        alipayUrl: '',
        payMethod: 1,
        qrcode: '',
        walletPayResult: ''
      }
    }
  }, {
    namespace: 'locatedToTab',
    os: ['ywk'],
    params: {
      /**
       * 0  在线商机
       * 1  黄豆纳才
       * 3  消息
       * 4  我的
       */
      index: ''
    }
  }]);
}